module.exports = __webpack_public_path__ + "static/media/3_r_rinok_42.71_40.83.e0c5cc50.png";